import { render, staticRenderFns } from "./kaidan_add.vue?vue&type=template&id=38bce0d0&scoped=true"
import script from "./kaidan_add.vue?vue&type=script&lang=js"
export * from "./kaidan_add.vue?vue&type=script&lang=js"
import style0 from "./kaidan_add.vue?vue&type=style&index=0&id=38bce0d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38bce0d0",
  null
  
)

export default component.exports